module.exports = "<div class=\"mmc-app app-main\">\r\n    <app-body></app-body>\r\n</div>\r\n\r\n<!-- <router-outlet></router-outlet> -->\r\n"